var _polygon, _path, _path2, _path3, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path4, _path5, _polygon2, _path6, _ellipse, _path7, _path8, _ellipse2, _path9, _path10, _polygon3, _polygon4, _path11, _polygon5, _rect10, _path12, _path13, _path14, _path15, _circle2, _path16, _polygon6, _path17, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path18, _circle3, _path19, _path20, _rect11, _rect12, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawprojectl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 688.82902,
    height: 604.26798,
    viewBox: "0 0 688.82902 604.26798",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "439.653 580.795 427.455 579.572 426.367 531.939 444.371 533.744 439.653 580.795",
    fill: "#9e616a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M697.165,740.79788l-39.33362-3.94307.04986-.49751a15.38729,15.38729,0,0,1,16.844-13.77536l.001.00009,24.02362,2.40838Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M519.52851,542.55083H277.24539a21.68439,21.68439,0,0,1-21.6599-21.6599v-351.365a21.68439,21.68439,0,0,1,21.6599-21.6599H519.52851a21.6844,21.6844,0,0,1,21.65991,21.6599v351.365A21.6844,21.6844,0,0,1,519.52851,542.55083Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#e4e4e4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M519.955,528.73133h-243.136a6.68453,6.68453,0,0,1-6.6769-6.6769v-353.692a6.68453,6.68453,0,0,1,6.6769-6.6769H519.955a6.68454,6.68454,0,0,1,6.67691,6.6769v353.692A6.68454,6.68454,0,0,1,519.955,528.73133Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.88016,
    cy: 6.63336,
    r: 1.8426,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.96361,
    y: 200.91751,
    width: 160.60484,
    height: 5.96776,
    fill: "#e4e4e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.96361,
    y: 219.81544,
    width: 160.60484,
    height: 5.96776,
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.96361,
    y: 238.71343,
    width: 160.60484,
    height: 5.96776,
    fill: "#e4e4e4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.03448,
    y: 204.60568,
    width: 36.38733,
    height: 36.38733,
    fill: "#e4e4e4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.96361,
    y: 280.12027,
    width: 160.60484,
    height: 5.96776,
    fill: "#e4e4e4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 87.96361,
    y: 299.01821,
    width: 160.60484,
    height: 5.96776,
    fill: "#e4e4e4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.96361,
    y: 317.91619,
    width: 160.60484,
    height: 5.96776,
    fill: "#e4e4e4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37.03448,
    y: 283.80845,
    width: 36.38733,
    height: 36.38733,
    fill: "#e4e4e4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 372.61779,
    y: 222.08695,
    width: 67.45461,
    height: 65.11894,
    transform: "translate(-320.08365 15.85319) rotate(-21.14419)",
    fill: "#80bd85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.38122,294.96407l-25.44714-65.79638,68.09-26.33448,25.447,65.79639Zm-22.86047-64.65283,24.00439,62.06592,64.359-24.89112L412.88,205.42013Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M750.89929,740.38692c-23.04371,0-41.791-36.7539-41.791-81.92968a148.80179,148.80179,0,0,1,4.68506-37.75c.43384-1.65137.90356-3.28614,1.3977-4.86621,7.64063-24.61524,20.98975-39.3125,35.70826-39.3125,23.04345,0,41.79077,36.75292,41.79077,81.92871S773.94274,740.38692,750.89929,740.38692Zm0-161.85839c-13.59009,0-26.541,14.52539-33.79883,37.9082-.4856,1.55176-.94678,3.15722-1.37158,4.77344a146.81247,146.81247,0,0,0-4.62061,37.24218c0,44.07813,17.8501,79.93457,39.791,79.93457,21.94067,0,39.79077-35.85644,39.79077-79.92968S772.84,578.52853,750.89929,578.52853Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.387 594.008 396.275 589.297 396.459 588.004 442.571 592.715 442.387 594.008",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M761.01525,707.00411c-8.75561,0-15.3584-20.87109-15.3584-48.54687s6.60279-48.5459,15.3584-48.5459,15.3584,20.87011,15.3584,48.5459S769.77087,707.00411,761.01525,707.00411Zm0-95.09277c-6.42431,0-13.3584,17.7959-13.3584,46.5459,0,28.751,6.93409,46.54687,13.3584,46.54687s13.3584-17.7959,13.3584-46.54687C774.37365,629.70724,767.43957,611.91134,761.01525,611.91134Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 507.06148,
    cy: 510.59156,
    rx: 5.54755,
    ry: 10.92041,
    fill: "#cacaca"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M846.83923,741.39767c-23.76319,0-43.096-37.33887-43.096-83.23438a149.67011,149.67011,0,0,1,4.62549-37.59863c.47168-1.79785.97-3.53906,1.48291-5.18067,7.85351-25.33105,21.68091-40.45507,36.98755-40.45507,23.76318,0,43.09619,37.33886,43.09619,83.23437S870.60241,741.39767,846.83923,741.39767Zm0-164.46875c-14.16919,0-27.61011,14.96289-35.07788,39.04882-.5044,1.61524-.99414,3.32618-1.4563,5.08789a147.65964,147.65964,0,0,0-4.56177,37.09278c0,44.79785,18.43555,81.23926,41.096,81.23926,22.66064,0,41.09619-36.44141,41.09619-81.23438S869.49987,576.92892,846.83923,576.92892Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M856.95544,706.70919c-8.75586,0-15.3584-20.87012-15.3584-48.5459s6.60254-48.5459,15.3584-48.5459,15.3584,20.87012,15.3584,48.5459S865.7113,706.70919,856.95544,706.70919Zm0-95.0918c-6.42432,0-13.3584,17.7959-13.3584,46.5459s6.93408,46.5459,13.3584,46.5459,13.3584-17.7959,13.3584-46.5459S863.37975,611.61739,856.95544,611.61739Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 603.00166,
    cy: 510.29731,
    rx: 5.54755,
    ry: 10.92041,
    fill: "#cacaca"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M943.41451,741.80685h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#cacaca"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M701.05095,357.25156a10.05578,10.05578,0,0,0,7.47594,13.48578l5.09444,35.36984,13.8866-12.32867-6.96673-31.69768a10.11028,10.11028,0,0,0-19.49025-4.82927Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#9e616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.987 348.439 584.401 348.113 584.401 383.338 494.987 386.946 494.987 348.439",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "474.609 590.176 462.475 588.425 463.454 540.788 481.363 543.373 474.609 590.176",
    fill: "#9e616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M731.59171,750.25047l-39.12548-5.646.0714-.49488A15.38731,15.38731,0,0,1,709.96344,731.078l.001.00014,23.89649,3.4485Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.625 467.911 417.323 467.839 421.272 396.083 502.167 396.083 502.167 397.388 422.508 397.388 418.625 467.911",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 709.43419,
    y: 719.02957,
    width: 1.30591,
    height: 55.66345,
    transform: "translate(-400.05609 1174.97845) rotate(-80.42636)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M812.08554,615.84517q-.73425,2.35939-1.38361,4.81658l-1.36407.15009-42.44867,4.71869-97.24555-9.7898,101.1615-5.22119L810.8063,615.682Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M789.84878,373.91922s-14.13537-4.50691-23.22241,13.52076S743.404,425.29812,743.404,425.29812l8.07739,1.80278s2.01935-12.61937,7.06769-14.42215l-2.01935,16.22492S817.11,447.83276,844.371,427.1009l-1.00964-6.30969s4.03869.90139,4.03869,6.30969l3.029-2.70414s-3.029-5.4083-12.116-12.61937c-5.96436-4.733-8.01392-13.73757-8.71827-19.36734a22.224,22.224,0,0,0-6.044-12.763C817.51187,373.399,806.50833,366.75822,789.84878,373.91922Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M738.3688,570.56773l-1.972,7.02537s-39.73644-9.63838-44.91312,15.28318S679.20758,694.929,679.20758,694.929l20.06545,4.11665,19.055-84.08255L795.50847,598.127l-5.05328-43.55729Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M771.78409,582.129s-53.5177-11.09515-57.4336,15.6637,1.958,77.66589,2.6106,78.97119-2.6106,25.45355-2.6106,25.45355l23.49555,3.26331s15.011-71.13935,8.48449-89.4137l44.15845-2.73145c15.24316-.94287,27.69592-12.98425,28.57251-28.23132.33551-5.83643-1.12543-11.13342-6.16022-14.07037-15.66369-9.13715-44.38049-9.13715-44.38049-9.13715Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.65218,
    cy: 267.66797,
    r: 23.49556,
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M775.04739,452.81935l-15.011-1.8739L749,477s-15.39621,95.66554-11.4802,96.9709a17.64827,17.64827,0,0,0,6.85285.979l74.093,3.857s3.3053-14.90491,2-26,13.9733-71.83916,13.9733-71.83916l-2.937-27.73782L819,453l-9-7-25.0468-.07806Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#e4e4e4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.103 306.343 504.451 302.427 486.176 280.237 467.415 218.134 449.415 237.134 468.555 297.858 494.661 331.144 505.103 306.343",
    fill: "#e4e4e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M766.37063,418.34388s8.0774-11.10638,15.14508-13.12573,8.0774-12.11606,8.0774-12.11606,18.17407,20.19342,29.28045,21.2031,1.00965-24.23209,1.00965-24.23209l-20.19342-5.04834-19.18372,2.01935L765.361,397.14082Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#2f2e41"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "586.36 429.391 585.728 402.609 524.992 402.609 523.051 474.419 521.746 474.384 523.721 401.304 586.99 401.304 587.011 401.935 587.664 429.346 586.36 429.391",
    fill: "#3f3d56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.054 392.82 583.748 392.82 583.748 343.002 604.816 349.118 604.451 350.371 585.054 344.74 585.054 392.82",
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "594.191 341.913 607.897 347.134 605.286 354.313 594.191 349.744 594.191 341.913",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.021 398.041 540.021 408.483 578.906 408.483 578.906 398.735 540.021 398.041",
    fill: "#3f3d56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "440.164 392.82 440.164 403.262 479.05 403.262 479.05 393.513 440.164 392.82",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M766.88919,515.34779h-.31726v-8.69074a5.03,5.03,0,0,0-5.03-5.03H743.12942a5.03,5.03,0,0,0-5.03,5.03h0v47.67817a5.03,5.03,0,0,0,5.03,5.03H761.542a5.03,5.03,0,0,0,5.03-5.03V521.534h.31726Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.90883,
    cy: 368.57172,
    r: 3.08105,
    fill: "#d0cde1"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "570.695 337.997 568.737 375.198 540.021 381.072 566.127 370.629 570.695 337.997",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M708.8201,353.67805v-78.707h230v58.20459h-209.498Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M708.8201,353.67805v-78.707h230v58.20459h-209.498Zm2-76.707V348.85l17.67382-17.67432H936.8201V276.971Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 505.10115,
    y: 141.75158,
    width: 128.26666,
    height: 10.39999,
    fill: "#80bd85"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 505.10115,
    y: 157.35158,
    width: 128.26666,
    height: 10.39999,
    fill: "#80bd85"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M758.32315,551.49693a10.05576,10.05576,0,0,0,14.331-5.69008l35.73092-.52973L797.9334,529.928l-32.32833,2.85623a10.11027,10.11027,0,0,0-7.28192,18.7127Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#9e616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M824.32278,457.79835l5.8739-4.56857s9.7898-5.22125,11.74781,13.0531,16.31634,78.97122,1.958,79.62387S776,548,776,548l-2-18,52.9335-4.97826Z",
    transform: "translate(-255.58549 -147.86601)",
    fill: "#e4e4e4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawprojectl);
export default __webpack_public_path__ + "static/media/undrawprojectl.fedbe6ec83cefef925c05cbf3f149b64.svg";
export { ForwardRef as ReactComponent };